// 退砼相关接口
import request from '@/utils/request'

// 列表
export function getList(params) {
  const { page: current, limit: size, sort, sortProp, ...otherWhere } = params
  const whereKey = 'srcr'
  const payload = {
    page: {
      current,
      size,
    },
    where: Object.entries(otherWhere).reduce((where, [name, value]) => (where[`lk_${whereKey}.${name}`] = value, where), {}),
  }
  if (sort) {
    let value = "";
    if (sort === "ascending") value += `asc_${whereKey}.`;
    if (sort === "descending") value += `desc_${whereKey}.`;
    if (value) {
      value += sortProp;
      payload.where[value] = 1;
    }
  } else {
    payload.where["asc_srcr.createTime"] = "1"
  }
  return request.post('/returnConcrete/getPage', payload)
}

// 根据编号查询指定内容
export function findBySingleNo(singleNo) {
  return request.post('/returnConcrete/findBySingleNo/' + singleNo)
}

// 退砼
export function returnConcrete(id) {
  return request.post('/ship/returnConcrete/' + id)
}

// 退砼
export function auditConcrete(payload) {
  const { id, audit } = payload
  return request.post(`/returnConcrete/audit/${id}/${audit}`)
}